
import { generateQueryParams } from 'utils/interfaces';
import CommonService from './common.service';

class CategoryService extends CommonService {
	async getCategories(params?: { [key: string]: string | boolean }) {
		const query = generateQueryParams(params);
		return await this.get(`categories/?${query}`);
	}
	async getCategoryDetails(id: string) {
		return await this.get(`categories/${id}`)
	}
	async createCategory(parmas: { [key: string]: boolean | string }) {
		return await this.post('categories', parmas)
	}
	async updateCategory(id: string, params: { [key: string]: boolean | string }) {
		return await this.put(`users/${id}`, params)
	}
	async deleteCategory(id: string) {
		return await this.delete(`users/${id}`)
	}
}
export const categoryService = new CategoryService();
